import React from "react";
import Styles from "./styles/tab.module.scss";

const tabList = [
  {
    key: 1,
    title: "Job Role",
  },
  {
    key: 2,
    title: "Requests",
  },
  {
    key: 3,
    title: "Approved",
  },
];
const Tab = ({ setActiveTab, activeTab }) => {
  return (
    <div className={Styles.topNav}>
      {tabList.map(({ key, title }) => {
        return (
          <span
            onClick={() => {
              setActiveTab(key);
            }}
            className={activeTab === key ? Styles.active : Styles.inactive}
          >
            {title}
          </span>
        );
      })}
    </div>
  );
};

export default Tab;
